import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthStateService } from '../services/auth-state.service';

export const registerFlowGuard: CanActivateFn = () => {

  const authState = inject(AuthStateService);

  const router = inject(Router);

  authState.loadState();

  if (!authState.registrationState().role) {

    return router.createUrlTree([
      '/auth/register'
    ]);

  }

  return true;

};